export function languageIso(
  defaultLanguaje = "es",
  allowedLanguages = ["es", "en"]
) {
  const navigatorLanguaje = window.navigator.language;
  const twoCharIso = navigatorLanguaje.substr(0, 2);
  return allowedLanguages.includes(twoCharIso) ? twoCharIso : defaultLanguaje;
}
